// extracted by mini-css-extract-plugin
export var centerText = "_5c-8";
export var container = "_5c-0";
export var doughnutContainer = "_5c-7";
export var legend = "_5c-a";
export var legendItemColorDisplay = "_5c-b";
export var legendItemLabel = "_5c-d";
export var legendItemValue = "_5c-c";
export var lg = "_5c-5";
export var maxWidth = "_5c-9";
export var md = "_5c-4";
export var responsive = "_5c-6";
export var sm = "_5c-3";
export var xs = "_5c-2";
export var xxs = "_5c-1";